import React, { useState } from 'react';
import api from '../api';
import LanguageSwitcher from '../LanguageSwitcher';

export default function Login({ t, lang, setLang, initialError }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!email.trim()) return;
    setBusy(true);
    try { await api.requestLink(email.trim(), lang); } catch {}
    setSent(true); setBusy(false);
  };

  return (
    <div className="center">
      <div className="card" style={{ width: 420, maxWidth: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <div className="h1">🤝 {t('portal')}</div>
          <LanguageSwitcher lang={lang} onChange={setLang} />
        </div>
        <div className="muted" style={{ marginBottom: 20 }}>{t('subtitle')}</div>

        {initialError && <div className="banner banner-err">{t('linkError')}</div>}

        {sent ? (
          <div className="banner banner-ok">{t('sent')}</div>
        ) : (
          <>
            <label className="muted" style={{ display: 'block', marginBottom: 6 }}>{t('email')}</label>
            <input className="input" type="email" value={email} placeholder={t('emailPh')}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submit()} />
            <button className="btn" style={{ width: '100%', marginTop: 14 }} disabled={busy} onClick={submit}>
              {busy ? t('sending') : t('requestBtn')}
            </button>
            <div className="muted" style={{ marginTop: 14, fontSize: 12 }}>{t('noPassword')}</div>
          </>
        )}
      </div>
    </div>
  );
}
